// extracted by mini-css-extract-plugin
export default {"countdown":"L0-z","srOnly":"M0-z"};